export default __webpack_public_path__ + "static/media/cloudFormation.bb2218c5.svg";